var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: "nord-svg inline-block mr-2",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.378 13.516L8.902 1.534c-.385-.712-1.42-.712-1.805 0L.622 13.516C.259 14.188.752 15 1.524 15h12.953c.77 0 1.264-.812.901-1.484zM8 12.982a1.016 1.016 0 0 1-1.023-1.009c0-.557.459-1.009 1.023-1.009.564 0 1.023.452 1.023 1.01 0 .556-.459 1.008-1.023 1.008zm1.023-3.027H6.977V5.92h2.046v4.036z",
    fill: "#F64F64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.417ba8ec336f5799ca9f0293c58acd45.svg";
export { ForwardRef as ReactComponent };